import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function deleteDiscount(token, params) {
    return Api.delete(REQUEST_URLS.COMPANY_APPROVAL.DISCOUNT, {
        params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default deleteDiscount;